export default import.meta.ROLLDOWN_FILE_URL_zvn4ySLRE4XjdOqFahk7IQ